import { MAX_SHEETS } from './../../action-types/bookproperties';

export const STATE_KEY = 'maxSheets';

export const maxSheets = (state = 10, action) => {
  switch (action.type) {
    case MAX_SHEETS: {
      return action.pages;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/maxSheets.js